import "./RecurringIssues.scss";

import { Tooltip } from "react-tippy";

import { ReactComponent as IssueIcon } from "../../assets/icons/exclamation.svg";
import { useThreadContext } from "../../scenes/thread/ThreadContext";
import Spinner from "../Spinner";
import useRecurringIssues from "./useRecurringIssues";

const RecurringIssues = () => {
  const { propertyInfo } = useThreadContext();
  const { recurringIssues, loading } = useRecurringIssues(
    propertyInfo?.property?.id,
    propertyInfo?.booking?.id
  );

  if (loading) {
    return <Spinner small />;
  }

  return (
    Object.keys(recurringIssues).length > 0 && (
      <Tooltip
        className="RecurringIssues"
        html={
          <div className="tooltip">
            <h4>Property issues recurring in this booking:</h4>
            {Object.entries(recurringIssues).map(([key, issue]) => (
              <p key={key}>
                - {issue.display_name}
                {issue.booking_count && (
                  <span className="booking-count">
                    {" "}
                    - {issue.booking_count} booking
                    {issue.booking_count > 1 ? "s" : ""}
                  </span>
                )}
              </p>
            ))}
          </div>
        }
        position="bottom"
        trigger="click"
        interactive
      >
        <IssueIcon onClick={event => event.stopPropagation()} />
      </Tooltip>
    )
  );
};

export default RecurringIssues;
